export default {
  "mainVegetable": "groensaker",
  "mainVegetable/01": "groensaker/auberginer",
  "mainVegetable/02": "groensaker/sparris",
  "mainVegetable/03": "groensaker/avokado",
  "mainVegetable/04": "groensaker/roedbetor",
  "mainVegetable/05": "groensaker/broccoli",
  "mainVegetable/06": "groensaker/moroetter",
  "mainVegetable/07": "groensaker/selleri",
  "mainVegetable/08": "groensaker/champinjoner",
  "mainVegetable/09": "groensaker/kal",
  "mainVegetable/10": "groensaker/brysselkal",
  "mainVegetable/11": "groensaker/kinakal",
  "mainVegetable/12": "groensaker/blomkal",
  "mainVegetable/13": "groensaker/coleslaw",
  "mainVegetable/14": "groensaker/gurkor",
  "mainVegetable/15": "groensaker/squash",
  "mainVegetable/16": "groensaker/endiver",
  "mainVegetable/17": "groensaker/spenat",
  "mainVegetable/18": "groensaker/bondbonor",
  "mainVegetable/19": "groensaker",
  "mainVegetable/20": "groensaker",
  "mainVegetable/21": "groensaker/torkade-bonor",
  "mainVegetable/22": "groensaker/haricots-verts",
  "mainVegetable/23": "groensaker/linser",
  "mainVegetable/24": "groensaker/gronsaksblandning",
  "mainVegetable/25": "groensaker/majs",
  "mainVegetable/26": "groensaker/salladsmix",
  "mainVegetable/27": "groensaker/majrova",
  "mainVegetable/28": "groensaker/lok",
  "mainVegetable/29": "groensaker/edamamebonor",
  "mainVegetable/30": "groensaker/paprikor",
  "mainVegetable/31": "groensaker/potatis",
  "mainVegetable/32": "groensaker/bongroddar",
  "mainVegetable/33": "groensaker/radisor",
  "mainVegetable/34": "groensaker/bladsallad",
  "mainVegetable/35": "groensaker/krussallad",
  "mainVegetable/36": "groensaker/isbergssallad",
  "mainVegetable/37": "groensaker",
  "mainVegetable/38": "groensaker/rissallad",
  "mainVegetable/39": "groensaker/romansallad",
  "mainVegetable/40": "groensaker",
  "mainVegetable/41": "groensaker/sallad",
  "mainVegetable/42": "groensaker/machésallad",
  "mainVegetable/43": "groensaker/rucola",
  "mainVegetable/44": "groensaker",
  "mainVegetable/45": "groensaker",
  "mainVegetable/46": "groensaker/tomater",
  "mainVegetable/47": "groensaker/smorbonor",
  "mainVegetable/48": "groensaker/kikartor",
  "mainVegetable/49": "groensaker/purjolok",
  "mainVegetable/50": "groensaker/pumpa",
  "mainVegetable/51": "groensaker/roda-kidneybonor",
  "mainVegetable/52": "groensaker/applen",
  "mainVegetable/53": "groensaker/kastanjer",
  "mainVegetable/54": "groensaker/plommon",
  "mainVegetable/55": "groensaker",
  "mainVegetable/56": "groensaker/svarta-oliver",
  "mainVegetable/57": "groensaker/kronartskockor",
  "mainVegetable/58": "groensaker/roda-paprikor",
  "mainVegetable/59": "groensaker",
  "mainVegetable/60": "groensaker",
  "mainVegetable/61": "groensaker/ratatouille",
  "mainVegetable/62": "groensaker/couscous",
  "mainVegetable/63": "groensaker",
  "mainVegetable/64": "groensaker",
  "mainVegetable/65": "groensaker",
  "mainVegetable/66": "groensaker",
  "mainVegetable/67": "groensaker/roda-linser",
  "mainVegetable/68": "groensaker/quinoa",
  "mainVegetable/69": "groensaker/spelt",
  "mainVegetable/70": "groensaker/bulgur",
  "mainVegetable/71": "groensaker/rodkal",
  "mainVegetable/72": "groensaker/gronkal",
  "mainVegetable/73": "groensaker/korvel",
  "mainVegetable/74": "groensaker",
  "mainVegetable/75": "groensaker/baljvaxter",
  "mainVegetable/76": "groensaker/sotpotatis",
  "mainVegetable/77": "groensaker/pumpa",
  "mainVegetable/78": "groensaker",
  "mainVegetable/79": "groensaker/bonor",
  "mainVegetable/80": "groensaker/artor-och-morotter",
  "mainVegetable/81": "groensaker/artor",
  "mainVegetable/82": "groensaker/edamamebonor",
  "mainVegetable/83": "groensaker",
  "mainVegetable/84": "groensaker",
  "mainVegetable/85": "groensaker",
  "mainVegetable/86": "groensaker",
  "mainVegetable/87": "groensaker",
  "mainVegetable/88": "groensaker",
  "mainVegetable/89": "groensaker",
  "mainVegetable/90": "groensaker/palsternacka",
  "mainVegetable/91": "groensaker",
  "mainVegetable/92": "groensaker/bonmix",
  "mainVegetable/93": "groensaker/svarta-bonor",
  "mainVegetable/94": "groensaker/spetskal",
  "mainVegetable/95": "groensaker/vita-bonor",
  "mainVegetable/96": "groensaker",
  "mainVegetable/97": "groensaker",
  "mainVegetable/98": "groensaker",
  "season": "arstid",
  "season/1": "arstid/sommar",
  "season/2": "arstid/host",
  "season/3": "arstid/vinter",
  "season/4": "arstid/var",
  "season/5": "arstid",
  "technologie": "teknik",
  "technologie/AC01": "teknik/konserver",
  "technologie/AD01": "teknik",
  "technologie/AG01": "teknik",
  "technologie/AT01": "teknik",
  "recipeDish": "ratt",
  "recipeDish/ACC": "ratt/tillbehor",
  "recipeDish/APE": "ratt",
  "recipeDish/DES": "ratt/efterratt",
  "recipeDish/ENT": "ratt/forratt",
  "recipeDish/PLAT": "ratt/huvudratt",
  "recipeDish/SAL": "ratt/sallad",
  "recipeDish/SNA": "ratt/snacks",
  "recipeDish/PDE": "ratt/frukost",
  "recipeDish/DEJ": "ratt/lunch",
  "recipeDish/TRA": "ratt/traditionell",
  "recipeDish/GOU": "ratt/gourmet",
  "recipeDish/ETH": "ratt/etnisk",
  "recipeDish/FCH": "ratt/barnvanlig",
  "recipeDish/SOU": "ratt/soppa",
  "pred-recipeTimingCook-facet": "tillagningstid",
  "pred-recipeTimingCook-facet/0%20-%2015%20min": "tillagningstid/0-15-minuter",
  "pred-recipeTimingCook-facet/15%20-%2030%20min": "tillagningstid/15-30-minuter",
  "pred-recipeTimingCook-facet/30%20-%2045%20min": "tillagningstid/30-45-minuter",
  "pred-recipeTimingCook-facet/45%20min%20and%20more": "tillagningstid/45-minuter",
  "pred-recipeTimingPreparation-facet": "forberedelsetid",
  "pred-recipeTimingPreparation-facet/0%20-%2015%20min": "forberedelsetid/0-15-minuter",
  "pred-recipeTimingPreparation-facet/15%20-%2030%20min": "forberedelsetid/15-30-minuter",
  "pred-recipeTimingPreparation-facet/30%20-%2045%20min": "forberedelsetid/30-45-minuter",
  "pred-recipeTimingPreparation-facet/45%20min%20and%20more": "forberedelsetid/45-minuter",
  "pred-recipeCost-Facet": "budget",
  "pred-recipeCost-Facet/petit": "budget/lag",
  "pred-recipeCost-Facet/moyen": "budget/mellan",
  "pred-recipeCost-Facet/grand": "budget/hog",
  "recipeDifficulty": "svarighetsgrad",
  "recipeDifficulty/1": "svarighetsgrad/latt",
  "recipeDifficulty/2": "svarighetsgrad/medium",
  "recipeDifficulty/3": "svarighetsgrad/svar",
  "recipeDishNumber": "antal-portioner",
  "recipeDishNumber/1": "antal-portioner/1",
  "recipeDishNumber/2": "antal-portioner/2",
  "recipeDishNumber/3": "antal-portioner/3",
  "recipeDishNumber/4": "antal-portioner/4",
  "recipeDishNumber/5": "antal-portioner/5",
  "recipeDishNumber/6": "antal-portioner/6",
  "recipeDishNumber/7": "antal-portioner/7",
  "recipeDishNumber/8": "antal-portioner/8",
  "productTheme": "produktteman",
  "productTheme/ACC": "produktteman/tillbehor",
  "productTheme/BEA": "produktteman/baljvaxter",
  "productTheme/BIS": "produktteman/bonor-i-sas",
  "productTheme/BIO": "produktteman/eko",
  "productTheme/CAN": "produktteman/konserver",
  "productTheme/CER": "produktteman",
  "productTheme/CLS": "produktteman/klassiker",
  "productTheme/DLE": "produktteman/gronsaker",
  "productTheme/EDR": "produktteman/mini-packs",
  "productTheme/ENT": "produktteman/forratter",
  "productTheme/FRZ": "produktteman/frysvaror",
  "productTheme/FSD": "produktteman/salladsingredienser",
  "productTheme/FSH": "produktteman",
  "productTheme/ING": "produktteman/ingredienser-till-mina-recept",
  "productTheme/JAR": "produktteman",
  "productTheme/LBW": "produktteman",
  "productTheme/LDF": "produktteman/ugnsbakade-gronsaker",
  "productTheme/LEG": "produktteman/baljvaxter",
  "productTheme/LGO": "produktteman",
  "productTheme/LGR": "produktteman",
  "productTheme/LGS": "produktteman",
  "productTheme/MAI": "produktteman/majs",
  "productTheme/MUS": "produktteman/champinjoner",
  "productTheme/NEW": "produktteman/nyheter",
  "productTheme/PDH": "produktteman",
  "productTheme/PDL": "produktteman",
  "productTheme/PHR": "produktteman",
  "productTheme/PLP": "produktteman/huvudratt",
  "productTheme/RAL": "produktteman",
  "productTheme/RDM": "produktteman",
  "productTheme/SAL": "produktteman",
  "productTheme/SDB": "produktteman/salladsbowls",
  "productTheme/SNK": "produktteman",
  "productTheme/SUP": "produktteman/soppa",
  "productTheme/TEX": "produktteman/tex-mex",
  "productTheme/VGP": "produktteman",
  "recipeTheme": "recepttema",
  "recipeTheme/01": "recepttema/hogtider",
  "recipeTheme/02": "recepttema",
  "recipeTheme/03": "recepttema/sallader-och-snacks",
  "recipeTheme/04": "recepttema/soppor",
  "recipeTheme/05": "recepttema",
  "recipeTheme/06": "recepttema",
  "recipeTheme/07": "recepttema/desserter",
  "recipeTheme/08": "recepttema/vegetarisk-mat",
  "recipeTheme/09": "recepttema/tillbehor",
  "recipeTheme/10": "recepttema",
  "recipeTheme/11": "recepttema",
  "recipeTheme/12": "recepttema",
  "recipeTheme/13": "recepttema/snacks-och-plockmat",
  "recipeTheme/14": "recepttema/huvudratter",
  "recipeTheme/15": "recepttema/efterratter-och-bakverk",
  "recipeTheme/16": "recepttema/forratter-och-soppor",
  "recipeTheme/17": "recepttema/sallader",
  "recipeTheme/18": "recepttema/bowls",
  "recipeTheme/19": "recepttema/soppor",
  "recipeTheme/20": "recepttema",
  "recipeTheme/21": "recepttema/saser",
  "recipeTheme/22": "recepttema",
  "recipeTheme/23": "recepttema/ovriga-ratter",
  "recipeTheme/24": "recepttema/ugnsbakade-ratter",
  "recipeTheme/25": "recepttema",
  "recipeTheme/26": "recepttema",
  "recipeTheme/27": "recepttema",
  "recipeTheme/28": "recepttema",
  "recipeTheme/33": "recepttema",
  "recipeTheme/34": "recepttema",
  "recipeTheme/35": "recepttema",
  "recipeTheme/36": "recepttema",
  "recipeTheme/37": "recepttema",
  "recipeTheme/38": "recepttema",
  "recipeTheme/39": "recepttema",
  "recipeTheme/40": "recepttema",
  "recipeTheme/41": "recepttema",
  "recipeTheme/42": "recepttema",
  "recipeTheme/43": "recepttema",
  "recipeTheme/44": "recepttema",
  "recipeTheme/45": "recepttema",
  "recipeTheme/46": "recepttema",
  "pred-particularite": "kategorier",
  "pred-particularite/Sans%20conservateur": "kategorier/utan-konserveringsmedel",
  "pred-particularite/Sel%20naturellement%20pr%E9sent": "kategorier",
  "pred-particularite/Sans%20colorant": "kategorier/utan-fargamnen",
  "pred-particularite/Sans%20sucre%20ajout%E9": "kategorier/utan-tillsatt-socker",
  "pred-particularite/Sans%20sel%20ajout%E9": "kategorier/utan-tillsatt-salt",
  "pred-particularite/Sans%20additif": "kategorier/utan-tillsatsamnen",
  "pred-particularite/": "kategorier/med-naturligt-saltinnehall",
  "pred-particularite/Sans%20lactose": "kategorier/laktosfri",
  "pred-particularite/Sans%20gluten": "kategorier/glutenfri",
  "pred-particularite/V%E9g%E9tarien": "kategorier/vegetarisk",
  "pred-particularite/V%E9g%E9talien": "kategorier/vegansk",
  "pred-particularite/Sans%20sulfite": "kategorier",
  "pred-particularite/A%20la%20vapeur": "kategorier",
  "pred-particularite/Sans%20condiment": "kategorier",
  "cultureType": "visa-bara",
  "cultureType/Bio": "visa-bara/eko",
  "cultureType/Sans%20r%E9sidu%20de%20pesticide": "visa-bara/inga-pesticidrester",
  "cultureType/Sans%20OGM": "visa-bara/gmo-fri",
  "nutriscore": "nutriscore",
  "pred-particularite/recipeVegan": "kategorier/vegansk",
  "pred-particularite/recipeVeggie": "kategorier/vegetarisk",
  "pred-particularite/recipeGlutenfree": "kategorier/glutenfri",
  "pred-particularite/recipeLactosefree": "kategorier/laktosfri"
};
